import { useEffect, useLayoutEffect, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useNavigationType } from "react-router-dom"

import { setScrollPos } from "app-store-v2/app/actions"

const ScrollTracker = () => {
  const prevPathname = useRef()
  const rafRef = useRef()
  const scrollPos = useRef(0)
  const action = useNavigationType()
  const { pathname } = useLocation()
  const dispatch = useDispatch()
  const active = useSelector((state) => state.scrollMap.active)

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual"

      return () => (window.history.scrollRestoration = "auto")
    }
  }, [])

  useEffect(() => {
    const handleScroll = () => {
      if (!rafRef.current) {
        rafRef.current = window.requestAnimationFrame(() => {
          scrollPos.current = window.scrollY
          rafRef.current = null
        })
      }
    }

    window.addEventListener("scroll", handleScroll)

    return () => {
      rafRef.current && window.cancelAnimationFrame(rafRef.current)
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  useLayoutEffect(() => {
    if (active && action === "PUSH" && prevPathname.current) {
      dispatch(setScrollPos(prevPathname.current, scrollPos.current))
    }

    prevPathname.current = pathname
  }, [action, active, pathname])

  useLayoutEffect(() => {
    if (action === "PUSH") {
      window.scrollTo(0, 0)
    }
  }, [action])

  return null
}

export default ScrollTracker
